var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("van-icon", {
            staticClass: "header-return",
            attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
            on: {
              click: function($event) {
                return _vm.onClickHeaderReturn()
              }
            }
          }),
          _vm._v("\n    Voltage Settings\n  ")
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "info" }, [
          _c("div", { staticClass: "info-title" }, [_vm._v("Name")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newVoltage.modeName,
                expression: "newVoltage.modeName",
                modifiers: { trim: true }
              }
            ],
            ref: "modeName",
            staticClass: "info-input",
            attrs: {
              type: "text",
              placeholder: "Please enter name",
              maxlength: "25"
            },
            domProps: { value: _vm.newVoltage.modeName },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newVoltage, "modeName", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _c("div", { staticClass: "info-title" }, [_vm._v("Description")]),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.newVoltage.description,
                expression: "newVoltage.description",
                modifiers: { trim: true }
              }
            ],
            ref: "description",
            staticClass: "pwd",
            attrs: {
              type: "text",
              placeholder: "Please enter description",
              maxlength: "500"
            },
            domProps: { value: _vm.newVoltage.description },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.newVoltage,
                  "description",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ]),
        _c("div", { staticClass: "flavor" }, [
          _c("div", { staticClass: "flavor-title" }, [
            _vm._v("\n        Flavor & Oil Type\n        "),
            _vm.model != "edit"
              ? _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.showFlavorPopup = true
                      }
                    }
                  },
                  [
                    _vm._v("Select "),
                    _c("img", {
                      attrs: { src: require("@/assets/icons/icon_right.png") }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm.selectFlavorList.length > 0
            ? _c(
                "div",
                { staticClass: "flavor-list" },
                _vm._l(_vm.selectFlavorList, function(item, index) {
                  return _c("div", { key: index, staticClass: "flavor-item" }, [
                    _c("img", { attrs: { src: item.flavorPicture } }),
                    _vm._v(
                      "\n          " + _vm._s(item.modelName) + "\n        "
                    )
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "flavor-list-empty" }, [
                _vm._v(
                  "\n        Please select the applicable flavor of the voltage setting\n      "
                )
              ])
        ]),
        _c("div", { staticClass: "voltage" }, [
          _vm._m(0),
          _c("div", { staticClass: "voltage-content" }, [
            _c(
              "div",
              { staticClass: "voltage-one" },
              _vm._l(_vm.voltageCurve.slice(0, 6), function(item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "voltage-number" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(Math.abs(item / 1000).toFixed(1)) +
                        "v\n          "
                    )
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass: "voltage-two",
                staticStyle: { width: "100%", height: "calc(20vh)" },
                attrs: { id: "voltageTwo" },
                on: {
                  touchmove: function($event) {
                    $event.preventDefault()
                    return _vm.onTouchmoveVoltage.apply(null, arguments)
                  }
                }
              },
              _vm._l(_vm.voltageCurve.slice(0, 6), function(value, index) {
                return _c("van-slider", {
                  key: index,
                  attrs: {
                    vertical: "",
                    min: "-4200",
                    max: "-100",
                    step: 100,
                    "bar-height": "4px",
                    "active-color": "#EEEEEE",
                    "inactive-color": "#6649C4",
                    disabled: _vm.model == "edit" ? true : false
                  },
                  on: {
                    change: function($event) {
                      return _vm.onChangeVoltageCurve(index)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function() {
                          return [
                            _c("img", {
                              staticClass: "slider-button",
                              attrs: {
                                src:
                                  _vm.model === "edit"
                                    ? require("@/assets/icons/icon_slider_button_disabled.png")
                                    : require("@/assets/icons/icon_slider_button.png")
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.voltageCurve[index],
                    callback: function($$v) {
                      _vm.$set(_vm.voltageCurve, index, $$v)
                    },
                    expression: "voltageCurve[index]"
                  }
                })
              }),
              1
            ),
            _c(
              "div",
              { staticClass: "voltage-three" },
              _vm._l(6, function(index) {
                return _c(
                  "div",
                  { key: index, staticClass: "voltage-number" },
                  [_vm._v("\n            " + _vm._s(index) + "s\n          ")]
                )
              }),
              0
            ),
            false
              ? _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "control-left" }, [
                    _c(
                      "div",
                      { staticClass: "title" },
                      [
                        _vm._v("\n              Preheat\n              "),
                        _c("van-switch", {
                          staticClass: "preheat-switch",
                          attrs: {
                            "active-value": "1",
                            "inactive-value": "0",
                            "active-color": "#66DCA5",
                            "inactive-color": "#D6CDF2",
                            size: "20",
                            disabled: _vm.model === "edit" ? true : false
                          },
                          on: {
                            change: function($event) {
                              return _vm.onClickModelItem(0)
                            }
                          },
                          model: {
                            value: _vm.newVoltage.preheatSetting,
                            callback: function($$v) {
                              _vm.$set(_vm.newVoltage, "preheatSetting", $$v)
                            },
                            expression: "newVoltage.preheatSetting"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "subtitle" }, [
                      _vm._v("\n              Times："),
                      _c(
                        "span",
                        {
                          style:
                            _vm.newVoltage.preheatSetting == 1
                              ? "color:#6649C4"
                              : "color:#555555"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              (_vm.newVoltage.preheatTime / 1000).toFixed(1)
                            ) + "s"
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "times-item" },
                      [
                        _c("van-slider", {
                          attrs: {
                            min: "1000",
                            max: "20000",
                            step: 500,
                            "bar-height": "4px",
                            "active-color": "#6649C4",
                            "inactive-color": "#FFFFFF",
                            disabled:
                              _vm.newVoltage.preheatSetting == 0 ? true : false
                          },
                          on: {
                            change: function($event) {
                              return _vm.onClickModelItem(0)
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _c("img", {
                                      staticClass: "slider-button",
                                      attrs: {
                                        src:
                                          _vm.newVoltage.preheatSetting == 1
                                            ? require("@/assets/icons/icon_slider_button_vertical.png")
                                            : require("@/assets/icons/icon_slider_button_vertical_disabled.png")
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3314926543
                          ),
                          model: {
                            value: _vm.newVoltage.preheatTime,
                            callback: function($$v) {
                              _vm.$set(_vm.newVoltage, "preheatTime", $$v)
                            },
                            expression: "newVoltage.preheatTime"
                          }
                        }),
                        _vm._m(1)
                      ],
                      1
                    ),
                    _c("div", { staticClass: "subtitle" }, [
                      _vm._v("\n              Voltage："),
                      _c(
                        "span",
                        {
                          style:
                            _vm.newVoltage.preheatSetting == 1
                              ? "color:#6649C4"
                              : "color:#555555"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              (_vm.newVoltage.preheatVoltage / 1000).toFixed(1)
                            ) + "v"
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "voltage-item" },
                      [
                        _c("van-slider", {
                          attrs: {
                            min: "100",
                            max: "4200",
                            step: 100,
                            "bar-height": "4px",
                            "active-color": "#6649C4",
                            "inactive-color": "#FFFFFF",
                            disabled:
                              _vm.newVoltage.preheatSetting == 0 ? true : false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    _c("img", {
                                      staticClass: "slider-button",
                                      attrs: {
                                        src:
                                          _vm.newVoltage.preheatSetting == 1
                                            ? require("@/assets/icons/icon_slider_button_vertical.png")
                                            : require("@/assets/icons/icon_slider_button_vertical_disabled.png")
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3314926543
                          ),
                          model: {
                            value: _vm.newVoltage.preheatVoltage,
                            callback: function($$v) {
                              _vm.$set(_vm.newVoltage, "preheatVoltage", $$v)
                            },
                            expression: "newVoltage.preheatVoltage"
                          }
                        }),
                        _vm._m(2)
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "control-right" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("NFC Settings")
                      ]),
                      _c("van-switch", {
                        staticClass: "nfc-switch",
                        attrs: {
                          "active-value": "1",
                          "inactive-value": "0",
                          "active-color": "#66DCA5",
                          "inactive-color": "#D6CDF2",
                          size: "20",
                          disabled: _vm.model === "edit" ? true : false
                        },
                        on: {
                          change: function($event) {
                            return _vm.onClickModelItem(0)
                          }
                        },
                        model: {
                          value: _vm.newVoltage.nfcSettings,
                          callback: function($$v) {
                            _vm.$set(_vm.newVoltage, "nfcSettings", $$v)
                          },
                          expression: "newVoltage.nfcSettings"
                        }
                      }),
                      _c("div", { staticClass: "msg" }, [
                        _vm._v(
                          "\n              Only use to that device support NFC\n            "
                        )
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm.supportLevel
          ? _c(
              "div",
              {
                staticClass: "device-level",
                staticStyle: { "margin-top": "10px" }
              },
              [
                _vm._v("\n      Curve：\n      "),
                _c(
                  "van-dropdown-menu",
                  [
                    _c(
                      "van-dropdown-item",
                      {
                        ref: "item",
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "drop-item-level" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.currentDeviceLevelItem.text
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3466245041
                        )
                      },
                      [
                        _vm._l(_vm.deviceLevelList, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "drop-item-level__wrap",
                              on: {
                                click: function($event) {
                                  return _vm.onLevelDropdown(item)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "drop-item-level__content",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center"
                                  }
                                },
                                [_c("span", [_vm._v(_vm._s(item.text))])]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.supportOutputDuration
          ? _c("div", { staticClass: "control" }, [
              _vm.supportCustomXYZModeOutputDuration
                ? _c(
                    "div",
                    { staticClass: "output-setting" },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v("\n          Output Settings\n        ")
                      ]),
                      _c(
                        "van-radio-group",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { direction: "horizontal" },
                          model: {
                            value: _vm.newVoltage.outputInterval,
                            callback: function($$v) {
                              _vm.$set(_vm.newVoltage, "outputInterval", $$v)
                            },
                            expression: "newVoltage.outputInterval"
                          }
                        },
                        [
                          _c(
                            "van-radio",
                            { attrs: { name: 250, "checked-color": "#000" } },
                            [_vm._v("X Mode")]
                          ),
                          _c(
                            "van-radio",
                            { attrs: { name: 500, "checked-color": "#000" } },
                            [_vm._v("Y Mode")]
                          ),
                          _c(
                            "van-radio",
                            { attrs: { name: 1000, "checked-color": "#000" } },
                            [_vm._v("Z Mode")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c("div", [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("\n          Output Duration\n        ")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newVoltage.outputInterval,
                          expression: "newVoltage.outputInterval"
                        }
                      ],
                      staticStyle: { "margin-top": "10px" },
                      attrs: { type: "number", min: 0, max: 2500 },
                      domProps: { value: _vm.newVoltage.outputInterval },
                      on: {
                        blur: _vm.onOutputDurationChange,
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.newVoltage,
                            "outputInterval",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "van-button",
            {
              staticClass: "footer-button",
              attrs: { type: "default" },
              on: { click: _vm.onClickSave }
            },
            [_vm._v("\n      Save\n    ")]
          )
        ],
        1
      ),
      _c(
        "van-popup",
        {
          staticClass: "flavor-popup",
          style: { height: "60%" },
          attrs: { position: "bottom", "close-on-click-overlay": false },
          model: {
            value: _vm.showFlavorPopup,
            callback: function($$v) {
              _vm.showFlavorPopup = $$v
            },
            expression: "showFlavorPopup"
          }
        },
        [
          _c("div", { staticClass: "flavor-header" }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/icon_left.png") },
              on: {
                click: function($event) {
                  _vm.showFlavorPopup = false
                }
              }
            }),
            _c("span", { staticClass: "header-title" }, [
              _vm._v("Applicable Flavor")
            ]),
            _c(
              "span",
              { staticClass: "header-dome", on: { click: _vm.onClickDome } },
              [_vm._v("DONE")]
            )
          ]),
          _c("div", { staticClass: "flavor-content" }, [
            _c("span", [_vm._v("Up to 5 can be selected")]),
            _vm.flavorList.length > 0
              ? _c(
                  "div",
                  { staticClass: "flavor-list" },
                  _vm._l(_vm.flavorList, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "flavor-item",
                        on: {
                          click: function($event) {
                            return _vm.onClickFlavorCheck(item, index)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "flavor-picture",
                          attrs: { src: item.flavorPicture }
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(item.modelName) +
                            "\n          "
                        ),
                        _c("img", {
                          staticClass: "flavor-checked",
                          attrs: {
                            src: item.checked
                              ? require("@/assets/icons/icon_checked.png")
                              : require("@/assets/icons/icon_unchecked.png")
                          }
                        })
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "flavor-list-empty" }, [
                  _vm._v("\n        No flavor\n      ")
                ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main-header" }, [
      _c("span", [_vm._v("Voltage Curve")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "times-item-msg" }, [
      _c("div", { staticClass: "times-left" }, [_vm._v("1 s")]),
      _c("div", { staticClass: "times-right" }, [_vm._v("20 s")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "voltage-item-msg" }, [
      _c("div", { staticClass: "voltage-left" }, [_vm._v("0.1 v")]),
      _c("div", { staticClass: "voltage-right" }, [_vm._v("4.2 v")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }